import React from "react";
import { Label, FormGroup as BootFormGroup } from "reactstrap";

export interface FormGroupProps {
    label: string;
    hasError?: boolean;
    showLabel?: boolean;
    htmlFor?: string;
    children?: React.ReactNode;
}

export const FormGroup = ({ hasError, children, label, showLabel, htmlFor }: FormGroupProps) => {
    return (
        <BootFormGroup className={hasError != null && hasError ? "has-danger" : ""}>
            <Label for={htmlFor} hidden={showLabel != null && !showLabel}>
                {label}
            </Label>
            {children}
        </BootFormGroup>
    );
};
